<template>
  <header class="header d-flex align-items-center px-4 position-fixed top-0 left-0 w-100 bg-white z-plus-10">
    <a
      :href="websiteLink"
      class="d-flex mr-auto">
      <svg-icon
        :icon="logoVariant.name"
        :size="logoVariant.size" />
    </a>
    <h1 class="h3 mb-0 mt-0 text-center flex-center clr-primary position-absolute w-100 m-auto top-0 bottom-0 left-0 right-0 z-minus-1">
      Lycaste AI
    </h1>
    <a
      :href="cabinetLink"
      class="d-flex">
      <svg-icon
        icon="user"
        size="md" />
    </a>
  </header>
</template>

<script>
export default {
  name: 'Header',
  computed: {
    currentBreakpoint() {
      /// Returns current 'morphological' breakpoint value based on window width
      ///
      /// @example
      ///   'xs' | 'sm' | 'md' | 'lg' | 'xl'

      return this.$store.state.config.currentBreakpoint
    },

    websiteLink() {
      return process.env.VUE_APP_WEBSITE
    },

    cabinetLink() {
      const cabinetToken = localStorage.getItem('id_token')

      if (cabinetToken) {
        return `${process.env.VUE_APP_CABINET}/cabinet/chat`
      } else {
        return `${process.env.VUE_APP_CABINET}/auth/signup`
      }
    },

    isDesktop() {
      return this.currentBreakpoint == 'md' || this.currentBreakpoint == 'lg' || this.currentBreakpoint == 'xl'
    },

    isMobile() {
      return this.currentBreakpoint == 'xs' || this.currentBreakpoint == 'sm'
    },

    logoVariant() {
      if (this.isDesktop) {
        return { name: 'logo-full', size: 'logo' }
      } else {
        return { name: 'logo-short', size: 'lg' }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/@core/globals';

.header {
  height: $header-height;
}
</style>
